import React from "react";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import { useField, useFormikContext } from "formik";
import CardButton from "./CardButton";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import propTypes from "prop-types";
import Box from "@mui/material/Box"; 

const PREFIX = "EnvironmentButtons";

const classes = {
  root: `${PREFIX}-root`,
  flexContainer: `${PREFIX}-flexContainer`,
};

const Root = styled("div")(() => ({
  margin: "0 auto",             
  maxWidth: "100%",          
  padding: "0 16px", 
  [`& .${classes.root}`]: {
    marginLeft: "0px",
    marginRight: "0px",
    display: "inline-flex",
  },
  [`& .${classes.flexContainer}`]: {
    display: "flex",
    flexDirection: "row", 
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    gap: "28px",
    maxWidth: "900px",
    margin: "0 auto", 
  },
}));

export default function EnvironmentButtons({ cards }) {
  const [field, meta, helpers] = useField("environment_id");
  const { touched, errors } = useFormikContext();
  const currentValue = meta.value;

  const formControlInfo = () =>
    cards.map((card, index) => (
      <Box key={index} sx={{ display: 'inline-flex' }}>
        <FormControlLabel
          control={
            <CardButton
              label={card.description}
              iconName={card.description}
              color={parseInt(currentValue?.code) === parseInt(card.code)}
              onClick={() => helpers.setValue(card)}
            />
          }
        />
      </Box>
    ));

  return (
    <Root>
      <Grid container justifyContent="center">
        <Grid item xs={12} md={10} lg={8} style={{ marginLeft: 'auto', marginRight: 'auto' }}>
          <Typography
            gutterBottom
            align="center"
            variant="subtitle1"
            component="span"
            sx={{ mb: 2 }}
          >
            What device/environment do you want your respondents to use?
          </Typography>
        </Grid>

        <Grid item xs={12} md={10} lg={8} style={{ marginLeft: 'auto', marginRight: 'auto' }}>
          <FormControl fullWidth>
            <FormGroup className={classes.flexContainer}>
              {formControlInfo()}
            </FormGroup>
            {touched.environment_id && errors.environment_id?.code && (
              <FormHelperText error variant="filled" sx={{ textAlign: "center" }}>
                {errors.environment_id.code}
              </FormHelperText>
            )}
          </FormControl>
        </Grid>
      </Grid>
    </Root>
  );
}

EnvironmentButtons.propTypes = {
  cards: propTypes.array,
};
